import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR } from '../../../store/types'
import { createSubject } from '../../../store/actions/subjectsActions'
import ModalActionButton from '../../elements/ModalActionButton'
import TextField from '../../elements/form/TextField'
import { Switch } from '@headlessui/react'
import { fetchDepartments } from '../../../store/actions/departmentActions'
import SelectField from '../../elements/form/SelectField'
import { fetchClasses } from '../../../store/actions/classesDivisionsActions'
import RadioGroup from '../../elements/form/RadioGroup'
import { studyTypeOptions } from '../../../utils'

const NewSubject = ({close, reload}) => {
  const [subjectPayload, setSubjectPayload] = useState({
    classes: []
  })
  const [validationErrors, setValidationErrors] = useState({})
  const dispatch = useDispatch()
  const subjectsSelector = useSelector(state => state.subjects)
  const departmentsSelector = useSelector((state => state.departments))
  // const classes = ['JSS1', 'JSS2', 'JSS3', 'SSS1', 'SSS2', 'SSS3']
  const classesSelector = useSelector(state => state.classes)

  useEffect(() => {
    dispatch(fetchClasses('', 0, 0))
    dispatch(fetchDepartments('', 0, 0))
  
    return () => {
      
    }
  }, [dispatch])
  

  const toggleClassSelection = (classOption) => {
      let tempPayload = {...subjectPayload}
      if(tempPayload.classes.includes(classOption)){
          tempPayload.classes.splice(tempPayload.classes.indexOf(classOption), 1)
      } else {
          tempPayload.classes.push(classOption)
      }
      setSubjectPayload(tempPayload)
  }

  const [forDepartment, setForDepartment] = useState(false)

  const validateForm = () => {
    let errors = {}
    
    if(!subjectPayload.name || subjectPayload.name === '') {
        errors.name = true
    }

    if(!subjectPayload.classes || subjectPayload.classes.length === 0) {
        errors.classes = true
    }

    if(forDepartment && (!subjectPayload.department || subjectPayload.department === '')) {
            errors.department = true
        }

    setValidationErrors(errors)
    return errors
  }

  const pushSubject = () => {
    if (Object.values(validateForm()).includes(true)) {
      dispatch({
          type: ERROR,
          error: {response: {data: {
              message: 'Please check the highlighted fields'
          }}}
      });
      return
    }

    const payload = {
      ...subjectPayload, 
      classes: subjectPayload.classes.map(cl => {
        return {
          class: cl._id
        }
      })}

    dispatch(createSubject(payload))
  }

  const includesSeniorClass = () => {
    const sssClassesExist = subjectPayload.classes.some(cl => cl.name.toLowerCase().includes('sss')) 
    const seniorClassesExist = subjectPayload.classes.some(cl => cl.type === 'SENIOR')
    return sssClassesExist || seniorClassesExist
  }
  return (
    <div className='w-full'>
      <div className='my-2'>
        <TextField
          inputLabel="Subject name" 
          fieldId="subject-name" 
          inputType="text" 
          requiredField={true}
          preloadValue={subjectPayload.name || ''}
          hasError={validationErrors && validationErrors.name} 
          returnFieldValue={(value)=>{setSubjectPayload({...subjectPayload, ...{name: value}})}}
          inputPlaceholder={`Eg: Mathematics`}
        />
      </div>

      <div className='my-2'>
        <TextField
          inputLabel="Shortname" 
          fieldId="short-name" 
          inputType="text" 
          requiredField={false}
          preloadValue={subjectPayload.shortName || ''}
          hasError={validationErrors && validationErrors.shortName} 
          returnFieldValue={(value)=>{setSubjectPayload({...subjectPayload, ...{shortName: value}})}}
          inputPlaceholder={`eg: Maths`}
        />
      </div>

      <div className='my-2'>
        <TextField
          inputLabel="Description" 
          fieldId="subject-description" 
          inputType="text" 
          requiredField={false}
          preloadValue={subjectPayload.description || ''}
          hasError={validationErrors && validationErrors.name} 
          returnFieldValue={(value)=>{setSubjectPayload({...subjectPayload, ...{description: value}})}}
          inputPlaceholder={`eg: Maths`}
        />
      </div>
      
      <div className='mt-4'>
        <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
          <div className='w-10/12'>
            <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Tie to a department</label>
            <label className="text-xs text-gray-500 font-sofia-pro">Will this subject be managed by one of the college departments?</label>
          </div>
          <div className='w-2/12 flex flex-row-reverse'>
            <Switch
              checked={forDepartment}
              onChange={
                ()=>{
                  setForDepartment(!forDepartment)
                  setSubjectPayload({...subjectPayload, ...{department: undefined}})
                }
              }
              className={`${
                forDepartment ? 'bg-accent' : 'bg-gray-400'
              } relative inline-flex items-center h-5 rounded-full w-10`}
              >
              <span className="sr-only">published</span>
              <span
                className={`transform transition ease-in-out duration-200 ${
                  forDepartment ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                } inline-block w-3 h-3 transform rounded-full`}
              />
            </Switch>
          </div>
        </div>
    </div>

    {forDepartment && <div className='mt-4'>
        <SelectField
            selectOptions={departmentsSelector?.departments?.departments}
            inputLabel="Select Department"
            titleField="name"
            displayImage={false}
            imageField=""
            preSelected=''
            fieldId="designation-department"
            hasError={false}
            // return id of accounts of the selected option
            returnFieldValue={(value) => {setSubjectPayload({...subjectPayload, ...{department: value._id}})}}
        />
    </div>}

      <div className='w-full mt-[20px]'>
        <label className={`block text-sm font-medium text-gray-700 font-sofia-pro mt-1 ${validationErrors.classes ? 'text-red-500' : 'text-gray-700'}`}><span className="text-red-500">*</span> Subject Classes</label>
        <label className="text-xs text-gray-500 font-sofia-pro">Select which classes this subject will be taught in below.</label>
      </div>
      <div className='w-full mt-4 flex items-center gap-x-[5px]'>
        {classesSelector?.classes?.classes?.map((entryClass, classIndex)=>(
            <button onClick={()=>{toggleClassSelection(entryClass)}} className={`px-3 py-1 text-sm rounded w-full border border-gray-300 font-space-grotesk font-[500] hover:bg-vcm-light-purple transition duration-200 ${subjectPayload.classes.includes(entryClass) ? 'bg-vcm-purple text-purple-200' : 'bg-gray-200 text-vcm-purple'}`} key={classIndex}>{entryClass.name}</button>
        ))}
      </div>

      {includesSeniorClass() && <div className='mt-4'>
        <RadioGroup 
          items={studyTypeOptions} 
          inline={true}
          preSelectedIndex={studyTypeOptions.findIndex(item => item.value === subjectPayload.studyType)}
          inputLabel={'Study Type'}
          requiredField={true}
          returnSelected={(value) => {setSubjectPayload({...subjectPayload, ...{studyType: value.value}})}} 
          hasError={validationErrors && validationErrors.studyType}
          titleField='label'
        />
      </div>}
            


      <div className="mt-8 flex flex-row-reverse gap-x-4">
        <ModalActionButton
          buttonLabel={`Create Subject`}
          buttonAction={()=>{pushSubject()}}
          processing={subjectsSelector.creatingSubject}
        />

        <button
          type="button"
          className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
          onClick={()=>{close()}}
        >
          Close
        </button>
          
      </div>
    </div>
  )
}

export default NewSubject